// // src/Components/Report/CustomHooks/useProfitLossReport.js
// import { useState, useEffect } from "react";
// import axios from "axios";
// import config from "../../../Helpers/config.json";

// export const useProfitLossReport = () => {
//   const today = new Date().toISOString().split("T")[0];

//   const [report, setReport] = useState({ summary: {}, sales_details: [], pagination: {} });
//   const [loading, setLoading] = useState(true);
//   const [from_date, setFromDate] = useState(today);
//   const [to_date, setToDate] = useState(today);
//   const [search, setSearch] = useState("");
//   const [page, setPage] = useState(1);
//   const [hasMore, setHasMore] = useState(true);

//   const per_page = 1000;

//   const fetchReport = async (reset = false) => {
//     if (!from_date || !to_date) return;

//     const currentPage = reset ? 1 : page;
//     setLoading(true);

//     try {
//       const res = await axios.get(`${config.epharmUrl}/Creport/general-profit-loss`, {
//         params: {
//           start_date: from_date,
//           end_date: to_date,
//           search: search || undefined,
//           page: currentPage,
//           per_page,
//         },
//       });

//       const data = res.data;

//       setReport(prev => ({
//         summary: data.summary || {},
//         sales_details: reset ? data.sales_details : [...prev.sales_details, ...data.sales_details],
//         pagination: data.pagination || {}
//       }));

//       setHasMore(data.pagination?.has_next || false);
//       if (reset) setPage(2);
//       else setPage(prev => prev + 1);
//     } catch (err) {
//       console.error("Error:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Initial load
//   useEffect(() => {
//     fetchReport(true);
//   }, []);

//   // Refetch on date/search change
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       fetchReport(true);
//     }, 600);
//     return () => clearTimeout(timer);
//   }, [from_date, to_date, search]);

//   const loadMore = () => {
//     if (!loading && hasMore) fetchReport();
//   };

//   const handleChangeDate = (e) => {
//     const { name, value } = e.target;
//     if (name === "from_date") setFromDate(value);
//     if (name === "to_date") setToDate(value);
//   };

//   return {
//     loading,
//     report,
//     from_date,
//     to_date,
//     search,
//     setSearch,
//     handleChangeDate,
//     loadMore,
//     hasMore,
//     per_page,
//   };
// };

// src/Components/Report/CustomHooks/useProfitLossReport.js
import { useState, useEffect } from "react";
import axios from "axios";
import config from "../../../Helpers/config.json";

export const useProfitLossReport = () => {
  const today = new Date().toISOString().split("T")[0];

  const [report, setReport] = useState({
    summary: {},
    retail_summary: {},
    wholesale_summary: {},
    sales_details: [],
    pagination: {}
  });

  const [loading, setLoading] = useState(true);
  const [from_date, setFromDate] = useState(today);
  const [to_date, setToDate] = useState(today);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const per_page = 1000;

  const fetchReport = async (reset = false) => {
    if (!from_date || !to_date) return;

    const currentPage = reset ? 1 : page;
    setLoading(true);

    try {
      const res = await axios.get(`${config.epharmUrl}/Creport/general-profit-loss`, {
        params: {
          start_date: from_date,
          end_date: to_date,
          search: search || undefined,
          page: currentPage,
          per_page,
        },
      });

      const data = res.data;

      setReport(prev => ({
        summary: data.summary || {},
        retail_summary: data.retail_summary || {},      // ← NEW
        wholesale_summary: data.wholesale_summary || {}, // ← NEW
        sales_details: reset 
          ? data.sales_details || [] 
          : [...prev.sales_details, ...(data.sales_details || [])],
        pagination: data.pagination || {}
      }));

      setHasMore(data.pagination?.has_next || false);
      if (reset) {
        setPage(2);
      } else {
        setPage(prev => prev + 1);
      }
    } catch (err) {
      console.error("Error fetching profit/loss report:", err);
    } finally {
      setLoading(false);
    }
  };

  // Initial load
  useEffect(() => {
    fetchReport(true);
    // eslint-disable-next-line
  }, []);

  // Refetch on filters change (debounced)
  useEffect(() => {
    const timer = setTimeout(() => {
      fetchReport(true);
    }, 600);

    return () => clearTimeout(timer);
    // eslint-disable-next-line
  }, [from_date, to_date, search]);

  const loadMore = () => {
    if (!loading && hasMore) {
      fetchReport();
    }
  };

  const handleChangeDate = (e) => {
    const { name, value } = e.target;
    if (name === "from_date") setFromDate(value);
    if (name === "to_date") setToDate(value);
  };

  return {
    loading,
    report,
    from_date,
    to_date,
    search,
    setSearch,
    handleChangeDate,
    loadMore,
    hasMore,
    per_page,
  };
};